
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/airport-security-wait-times/[market]",
      function () {
        return require("private-next-pages/airport-security-wait-times/[market].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/airport-security-wait-times/[market]"])
      });
    }
  